const kr = {
  100000001:'핵심 정보',
  100000002:'토큰 이름',
  100000003:'복사본 생성자',
  100000004:'복제 생성 시간',
  100000005:'기초 정보',
  100000006:'소속 퍼블릭 체인/프로토콜',
  100000007:'스마트 계약 주소',
  100000008:'발행 시간',
  100000009:'발행 총량',
  100000010:'유통 총량',
  100000011:'시가',
  100000012:'소개',
  100000013:'소셜 미디어 정보',
  100000014:'포털사이트',
  100000015:'백지',
  100000016:'블록체인 탐색기',
  100000017:'프로젝트 점수',
  100000018:'순위',
  100000019:'상위',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'업데이트 시간',
  100000027:'보안 점수',
  100000028:'스마트 계약 보안 점수',
  100000029:'위험 프로젝트 통계',
  100000030:'계약 코드 세부사항',
  100000031:'구매 세금',
  100000032:'판매 세금',
  100000033:'허니팟 여부',
  100000034:'재발행 가능 여부',
  100000035:'블랙리스트가 있습니까',
  100000036:'화이트리스트가 있습니까',
  100000037:'반고래 여부',
  100000038:'세율 변경 가능 여부',
  100000039:'오픈 소스 여부',
  100000040:'숨겨진 보유자 여부',
  100000041:'자가 파괴 가능 여부',
  100000042:'프록시 계약 여부',
  100000043:'잔액을 변경할 수 있습니까 ',
  100000044:'외부 호출을 실행할 수 있습니까',
  100000045:'소유권을 다시 획득할 수 있습니까',
  100000046:'거래 냉각 기간이 있습니까',
  100000047:'송금을 일시 중지할 수 있습니까',
  100000048:'소유권이 포기되지 않음',
  100000049:'조정 가능한 반고래입니까',
  100000050:'소수 자릿수가 너무 많음',
  100000051:'공개된 민트와 번(mint and burn) 방법',
  100000052:'토큰 소각이 총량을 업데이트합니까',
  100000053:'토큰 소각이 잔액을 업데이트합니까',
  100000054:'자전거래가 잔액을 증가시킵니까',
  100000055:'잔액보다 많은 토큰 전송이 무효화됩니까',
  100000056:'잔액이 전송 중에 업데이트되지 않음',
  100000057:'수신자의 잔액이 소모됩니까',
  100000058:'TransferFrom 호출이 잔액을 초과할 때 실패하나요',
  100000059:'BurnFrom 메서드는 총량을 업데이트하나요',
  100000060:'토큰의 구매 세금을 감지합니다. 5% 이상이면 높은 세율로 간주됩니다.',
  100000061:'토큰의 판매 세금을 감지합니다. 5% 이상이면 높은 세율로 간주됩니다.',
  100000062:'토큰이 허니팟 사기인지 확인합니다.',
  100000063:'더 많은 토큰을 발행할 수 있는지 확인합니다.',
  100000064:'사용자가 토큰 스왑 또는 전송을 제한할 수 있는 블랙리스트가 있는지 확인합니다.',
  100000065:'어떤 제한도 우회할 수 있는 주소를 허용하는 화이트리스트가 있는지 확인합니다.',
  100000066:'토큰에 반-고래 메커니즘이 있는지 확인합니다.',
  100000067:'토큰에 세금이 있으며, 세금이 특권 있는 역할에 의해 수정될 수 있는지 확인합니다.',
  100000068:'토큰이 블록체인 탐색기에 검증되었는지 확인합니다.',
  100000069:'소유권이 포기된 것처럼 보이더라도 계약을 조작할 수 있는 숨겨진 소유자가 있는지 확인합니다.',
  100000070:'토큰이 자가-파괴할 수 있는지 확인합니다.',
  100000071:'토큰이 함수 호출을 구현 계약으로 위임하는 프록시 계약인지 확인합니다.',
  100000072:'특권 있는 역할에 의해 토큰 잔액이 수정될 수 있는지 확인합니다.',
  100000073:'토큰이 외부 계약을 호출하는지 확인합니다.',
  100000074:'소유권을 다시 얻기 위한 백도어가 있는지 확인합니다.',
  100000075:'토큰에 전송 쿨다운 메커니즘이 있는지 확인합니다.',
  100000076:'특권 있는 역할에 의해 토큰 거래가 일시 정지될 수 있는지 확인합니다.',
  100000077:'소유권 권한이 포기되었는지 확인합니다.',
  100000078:'토큰의 반-고래 메커니즘이 특권 있는 역할에 의해 수정될 수 있는지 확인합니다.',
  100000079:'decimals() 함수의 반환값이 5 이상인지 확인합니다.',
  100000080:'임의의 사용자가 mint() 및 burn() 함수를 호출할 때 되돌려지는지 확인합니다.',
  100000081:'burn() 함수를 호출할 때 totalSupply가 올바르게 업데이트되는지 확인합니다.',
  100000082:"burnFrom() 함수를 호출할 때 허용량이 올바르게 업데이트되는지 확인합니다.",
  100000083:'수신자가 거래 발신자와 동일한 경우 transfer() 함수를 호출할 때 발신자의 잔액이 증가하는지 확인합니다.',
  100000084:'잔액보다 많은 금액으로 transfer() 함수를 호출할 때 실패하는지 확인합니다.',
  100000085:"transferFrom() 함수를 호출한 후 지출자의 허용량이 적절히 업데이트되는지 확인합니다.",
  100000086:"transferFrom() 함수를 호출할 때 지출자의 잔액을 사용하는지 확인합니다.",
  100000087:"transferFrom()을 호출한 후 허용량이 올바르게 업데이트되는지, 또는 금액이 유효하지 않을 경우 트랜잭션이 되돌려지는지 확인하세요.",
  100000088:"burnFrom() 함수를 호출할 때 totalSupply가 올바르게 업데이트되는지 확인하세요.",
  100000089:'발행 권한이 존재하는지 확인합니다.',
  100000090:'동결 권한이 존재하는지 확인합니다.',
  100000091:'메타데이터를 변경할 수 있는지 검토합니다.',
  100000092:'위급',
  100000093:'주요',
  100000094:'중간',
  100000095:'사소한',
  100000096:'정보',
  100000097:'Mint 권한이 포기되었나요',
  100000098:'동결 권한이 포기되었나요',
  100000099:'토큰의 메타데이터를 변경할 수 있나요',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default kr


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/kr.js